import { render, staticRenderFns } from "./kuaidi2.vue?vue&type=template&id=00c76be6&"
import script from "./kuaidi2.vue?vue&type=script&lang=js&"
export * from "./kuaidi2.vue?vue&type=script&lang=js&"
import style0 from "./kuaidi2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports